<!-- Send Bulk Whatsapp Modal -->
<p-dialog [visible]="showPopup()" (onHide)="closePopupUp()" [closeOnEscape]="false" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'991px': '100vw'}" [style]="{width: '870px'}" styleClass="no-header-modal">
  <ng-template pTemplate="header" styleClass="hidden" />
  <ng-template pTemplate="content" styleClass="p-0">
    <!-- Header -->
    <div class="p-3 sticky top-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300">
      @if (pushNotificationSendType()  === GetPushNotificationSendType.Bulk) {
        <h2 class="mb-0 text-sm">{{'SEND_PUSH_NOTIFICATION.SEND_BULK_PUSH_NOTIFICATION' | translate }}</h2>
      }
      @if (pushNotificationSendType() === GetPushNotificationSendType.FreeForm) {
        <h2 class="mb-0 text-sm" [innerHTML]="'SEND_PUSH_NOTIFICATION.SEND_FREE_FORM_PUSH_NOTIFICATION' | translate : { name: this.SelectedClient().value.full_name } "></h2>
      }
      @if (pushNotificationSendType() === GetPushNotificationSendType.Campaign) {
        <h2 class="mb-0 text-sm" >{{'SEND_PUSH_NOTIFICATION.PUSH_NOTIFICATION_CONFIG' | translate }}</h2>
      }
      @if (pushNotificationSendType() === GetPushNotificationSendType.Automation) {
        <h2 class="mb-0 text-sm" >{{'SEND_PUSH_NOTIFICATION.PUSH_NOTIFICATION_CONFIG' | translate }}</h2>
      }
      <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="closePopupUp()"></div>
    </div>
    <!-- Header -->
    <form [formGroup]="sendPushNotificationForm">

      @if (pushNotificationSendType() === GetPushNotificationSendType.Automation && showScheduleType.value) {
        <automation-schedule-type [formGroup]="sendPushNotificationForm" [automationMaster]="automationMaster()" [type]="'PUSH_NOTIFICATION'" />
      }

      <!-- Content -->
      <div class="p-3 surface-100">
        @if (showCampaign.value && pushNotificationSendType() === GetPushNotificationSendType.Bulk) {
          <div class="flex align-items-center mb-2">
            <strong class="text-sm mb-0 mr-2 -mt-1 cursor-pointer" >{{'SEND_PUSH_NOTIFICATION.IS_CAMPAIGNS' | translate }}</strong>
          <p-inputSwitch formControlName="is_visible" />
        </div>
      }

      <div class="surface-0 shadow-3 border-round relative text-sm">
        <!-- Campaign Fields Section -->
        @if (IsVisibleFormControl.value && pushNotificationSendType() === GetPushNotificationSendType.Bulk) {
          <div class="p-3">
            <!-- Form Group -->
            <div class="mb-3">
              <label for="campaign-name-input" class="font-medium text-700 text-xs mb-2 block uppercase">{{'SEND_WHATSAPP.CAMPAIGN_NAME' | translate }}</label>
              <input type="text" formControlName="campaign_name" class="text-sm w-full" pInputText [placeholder]="'SEND_EMAIL.NAME_PLACEHOLDER' | translate" />
              @if (CampaignNameFormControl.touched && CampaignNameFormControl.invalid) {
                <app-error-msg [errors]="CampaignNameFormControl.errors" [fieldLabel]="'SEND_EMAIL.CAMPAIGN_NAME_ERROR' | translate" />
              }
            </div>
            <!-- Form Group -->

            <!-- Form Group -->
            <div class="mb-3">
              <label for="campaign-description-input" class="font-medium text-700 text-xs mb-2 block uppercase">{{'SEND_WHATSAPP.CAMPAIGN_DESCRIPTION' | translate }}</label>
              <textarea pInputTextarea formControlName="campaign_description" class="text-sm w-full h-4rem" [placeholder]="'SEND_EMAIL.DESC_PLACEHOLDER' | translate"></textarea>
              @if (CampaignDescriptionFormControl.touched && CampaignDescriptionFormControl.invalid) {
                <app-error-msg [errors]="CampaignDescriptionFormControl.errors" [fieldLabel]="'SEND_EMAIL.CAMPAIGN_DESCRIPTION_ERROR' | translate" />
              }
            </div>
            <!-- Form Group -->

            <!-- Form Group -->
            <div class="mb-0">
              <label for="campaign-schedule-date-input" class="font-medium text-700 text-xs mb-2 block uppercase">{{'SEND_WHATSAPP.SCHEDULE_DATE_ERROR' | translate }}</label>
              <p-datepicker [showIcon]="true"
                formControlName="campaign_action_date"
                icon="fa fa-calendar font-light"
                dateFormat="M dd,yy"
                [yearNavigator]="true"
                yearRange="2023:2030"
                [placeholder]="'SEND_EMAIL.CHOOSE_DATE' | translate"
                inputStyleClass="text-sm"
               />
              @if (CampaignActionDateFormControl.touched && CampaignActionDateFormControl.invalid) {
                <app-error-msg [errors]="CampaignActionDateFormControl.errors" [fieldLabel]=" 'SEND_EMAIL.SCHEDULE_DATE' | translate" />
              }
            </div>
            <!-- Form Group -->
          </div>
        }

        <!-- Content Label -->
        @if (showCampaign.value && pushNotificationSendType() === GetPushNotificationSendType.Bulk) {
          <div class="px-3 pt-3 pb-2">
            <label for="content-input" class="font-medium text-700 text-xs mb-0 block uppercase">{{'SEND_WHATSAPP.CONTENT' | translate }}</label>
          </div>
        }
        
        <!-- Content Section -->
        <div class="surface-0 shadow-3 p-3 border-round text-sm">
          <!-- Form Group -->
          <div class="mb-3">
            <label for="choose-template-input" class="font-medium text-700 text-xs mb-2 block uppercase">{{'SEND_WHATSAPP.CHOOSE_TEMPLATE' | translate }}</label>
            <p-select
              [options]="pushNotificationTemplateMasters$.value"
              formControlName="push_notification_template"
              dropdownIcon="fa fa-chevron-down"
              optionLabel="name_primary_language"
              filterBy="name_primary_language"
              class="text-sm w-full"
              appendTo="body"
              [placeholder]="'SEND_EMAIL.CHOOSE_TEMPLATE' | translate"
              (onChange)="selectPushNotificationTemplate()"
              >
              <ng-template pTemplate="selectedItem">
                @if (SelectedPushNotificationTemplateFormControl.value) {
                  <strong class="text-sm text-primary">{{ SelectedPushNotificationTemplateFormControl.value.name_primary_language }}</strong>
                }
              </ng-template>
              <ng-template let-template pTemplate="item">
                <div class="text-sm">{{ template.name_primary_language }}</div>
              </ng-template>
            </p-select>
            @if (SelectedPushNotificationTemplateFormControl.touched && SelectedPushNotificationTemplateFormControl.invalid) {
              <app-error-msg [errors]="SelectedPushNotificationTemplateFormControl.errors" [fieldLabel]="'SEND_WHATSAPP.TEMPLATE' | translate" />
            }
          </div>
          <!-- Form Group -->

          <!-- Title -->
          <div class="pl-6 relative mb-2 border-top-1 border-bottom-1 border-300 py-2">
            <span class="absolute left-0 top-0 mt-3">{{'SEND_PUSH_NOTIFICATION.TITLE' | translate }}</span>
            <input type="text" formControlName="title" pInputText [placeholder]="'SEND_PUSH_NOTIFICATION.TITLE_PLACEHOLDER' | translate" class="p-inputtext-sm w-full ml-1"
              [ngClass]="{ 'ng-invalid ng-dirty': TitleFormControl.invalid && TitleFormControl.touched }"/>
              @if (TitleFormControl.touched && TitleFormControl.invalid) {
                <app-error-msg [errors]="TitleFormControl.errors" [fieldLabel]=" 'SEND_PUSH_NOTIFICATION.TITLE' | translate" />
              }
            </div>
            <!-- Title -->

            <!-- Form Group -->
            <div class="mb-3">
              <label for="content-input" class="font-medium text-700 text-xs mb-2 block uppercase">{{'SEND_EMAIL.CONTENT' | translate }}</label>
              <textarea pInputTextarea class="text-sm w-full h-7rem" formControlName="body" placeholder="The maximum limit for text is 300 characters..."></textarea>
              @if (BodyFormControl.touched && BodyFormControl.invalid) {
                <app-error-msg [errors]="BodyFormControl.errors" [fieldLabel]="'SEND_EMAIL.CONTENT_LABEL' | translate" />
              }
            </div>
            <!-- Form Group -->

            <!-- Subject -->
            <div class="mb-3">
              <span class="font-medium text-700 text-xs mb-2 block uppercase">{{'SEND_PUSH_NOTIFICATION.DEEP_LINK' | translate }}</span>
              <input type="text" formControlName="deep_link" pInputText [placeholder]="'SEND_PUSH_NOTIFICATION.DEEP_LINK' | translate" class="p-inputtext-sm w-full"
                [ngClass]="{ 'ng-invalid ng-dirty': DeepLinkFormControl.invalid && DeepLinkFormControl.touched }"/>
                @if (DeepLinkFormControl.touched && DeepLinkFormControl.invalid) {
                  <app-error-msg [errors]="DeepLinkFormControl.errors" [fieldLabel]=" 'SEND_PUSH_NOTIFICATION.DEEP_LINK' | translate" />
                }
              </div>
              <!-- Subject -->

            </div>

            <!-- Options -->
            @if (pushNotificationSendType() === GetPushNotificationSendType.FreeForm || pushNotificationSendType() === GetPushNotificationSendType.Campaign || pushNotificationSendType() === GetPushNotificationSendType.Automation) {
              <div class="surface-200 mt-2 text-center md:text-left py-1 md:px-3 px-0 md:flex align-items-center">
                <button pButton pRipple type="button" [label]="'SEND_PUSH_NOTIFICATION.UPLOAD_IMAGE' | translate" class="text-sm p-button-text ml-2">
                  <ngx-file-drop class="opacity-0 absolute w-full h-full top-0 left-0 z-4 cursor-pointer" dropZoneLabel="Upload Image" (onFileDrop)="handleFileSelect($event)">
                    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                      <div (click)="openFileSelector()" class="w-full h-full absolute left-0 top-0"></div>
                    </ng-template>
                  </ngx-file-drop>
                </button>
              </div>
            }
            <!-- Options -->
            <!-- Form Group -->
          </div>
        </div>
      <!-- Content -->

      <!-- Modal Footer -->
          <div class="p-3 sticky bottom-0 left-0 w-full surface-0 z-1 flex align-items-center justify-content-between border-top-1 border-300">
            <p-button [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" styleClass="p-button-link text-sm" (click)="closePopupUp()" />
            @if (pushNotificationSendType() !== GetPushNotificationSendType.Campaign && pushNotificationSendType() !== GetPushNotificationSendType.Automation) {
              <p-button [label]="'TABLE_ACTION_BTNS.SEND_PUSH_NOTIFICATION' | translate" [disabled]="!isFormValid" [loading]="btnLoading" styleClass="text-sm" (click)="SendPushNotification()" />
            }
            @if (pushNotificationSendType() === GetPushNotificationSendType.Campaign || pushNotificationSendType() === GetPushNotificationSendType.Automation) {
              <p-button [label]="'common.BUTTONS.SUBMIT-BUTTON-TEXT' | translate" [disabled]="!isFormValid" [loading]="btnLoading" styleClass="text-sm" (click)="SaveData()" />
            }
          </div>
          <!-- Modal Footer -->
        </form>
      </ng-template>
    </p-dialog>
    <!-- Send Bulk Whatsapp Modal -->
